module.exports = __webpack_public_path__ + "static/img/image_news_over_10.1df0f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_10.png
// module id = CNfL
// module chunks = 10